import script from "./ElementFlip.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementFlip.vue?vue&type=script&lang=ts&setup=true"

import "./ElementFlip.vue?vue&type=style&index=0&id=7571b056&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7571b056"]])

export default __exports__